import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import "./styles.scss";
import { RefPropTypes } from "../../propTypes";

const RadioDrop = ({
  disabled,
  label,
  input,
  value,
  onRadioButtonClick,
  selected,
  inputRef,
  onRadioButtonSelect,
}) => {
  return (
    <label
      className={classNames(
        "radio-drop",
        selected && "radio-drop-selected",
        disabled && "radio-drop-disabled"
      )}
    >
      <input
        type="radio"
        hidden
        ref={inputRef}
        name={input.name}
        value={value}
        checked={input.checked}
        disabled={disabled}
        onClick={e => {
          onRadioButtonSelect(e);
          onRadioButtonClick && onRadioButtonClick(e);
        }}
      />
      {label}
    </label>
  );
};

RadioDrop.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  input: PropTypes.object,
  value: PropTypes.any,
  onRadioButtonClick: PropTypes.func,
  onRadioButtonSelect: PropTypes.func,
  selected: PropTypes.bool,
  inputRef: RefPropTypes,
};

export default RadioDrop;
